import React from 'react'

const FStep4 = () => {
  return (
    <div>Congrates Your Password has reset successfully!</div>
  )
}

export default FStep4